import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, $hasHighlightCard }) => css`
    display: grid;
    gap: 24px;
    width: 100%;

    ${$hasHighlightCard && css`
      grid-template-columns: repeat(2, 1fr);
    `}

    ${!$hasHighlightCard && css`
      grid-template-columns: 1fr 1fr;
      grid-template-rows: 1fr 1fr;
    `}

    @media (max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(1, 1fr);
    }
  `}
`;

export const Card = styled.div`
  border-radius: 24px;
  box-shadow: 0 3px 6px 0 rgba(223, 226, 235, 0.20), 0 2px 4px 0 rgba(223, 226, 235, 0.14);
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  
  :nth-child(1) {
    grid-row: 1 / -1;
  }

  :hover {
    box-shadow: 0 3px 6px 0 rgba(223, 226, 235, 0.40), 0 2px 4px 0 rgba(223, 226, 235, 0.28);
    transform: translateY(-5px);
  }
`;

export const Image = styled.img`
  cursor: pointer;
  height: 100%;
  object-fit: cover;
  width: 100%;
`;
